import i18n, {InitOptions} from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import {registerUiKitTranslations} from '@chekin/guestapp-ui-kit';
import {registerSharedTranslations} from '@chekin/shared';
import {preloadAndSetDayJsLocale, LANGUAGE_CODES} from '@chekin/core';
import {LazyImport} from './plugins/lazyImportPlugin';
import ChekinProSettings from '../../ChekinProSettings';

const defaultLanguages = {
  es: [LANGUAGE_CODES.ca],
};

i18n.on('languageChanged', function (nextLanguage) {
  const fallbackLanguage = Object.keys(defaultLanguages).find(key => {
    return defaultLanguages[key as keyof typeof defaultLanguages].includes(
      nextLanguage as LANGUAGE_CODES,
    );
  });

  void preloadAndSetDayJsLocale(fallbackLanguage || nextLanguage);
});

const initParams: InitOptions = {
  lng: ChekinProSettings.defaultLanguage,
  fallbackLng: LANGUAGE_CODES.en,
  detection: {
    order: ['querystring', 'localStorage', 'navigator'],
  },
  load: 'languageOnly',
  interpolation: {
    escapeValue: false,
  },
  preload: [LANGUAGE_CODES.it, LANGUAGE_CODES.es, LANGUAGE_CODES.de],
  returnNull: false,
  returnEmptyString: false,
  fallbackNS: 'translation',
  react: {
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'ul', 'li'],
  },
};

void i18n
  .use(LazyImport)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(initParams, () => {
    registerUiKitTranslations(i18n);
    registerSharedTranslations(i18n);

    if (ChekinProSettings.defaultLanguage) {
      void preloadAndSetDayJsLocale(ChekinProSettings.defaultLanguage);
    }
  });

export {i18n};
